import { pipe } from 'rxjs'
import { AppRouteCreators, AppRouteName, GetFromQuery } from '../types/core'
import { routeToHref } from './routes'
import { basePathUrl, trimOrigin, trimSlashAndQuery } from './url'

export const getRouteNameFromHref = ({
  browserURL,
  router,
  routes,
  getSourceFromQuery = (_, sourceQuery) => sourceQuery,
  getStyleFromQuery = (_, styleQuery) => styleQuery,
  getActualStyleId,
}: {
  browserURL: string
  router: any
  routes: AppRouteCreators
  getSourceFromQuery?: GetFromQuery
  getStyleFromQuery?: GetFromQuery
  getActualStyleId?: (style: string) => string
}): AppRouteName => {
  const {
    query: {
      style: styleQuery,
      source: sourceQuery,
      q: query,
      id: projectId,
      id: citationId,
      id: paperId,
    },
  } = router
  const sourceType = getSourceFromQuery(router, sourceQuery)
  const style = getActualStyleId
    ? getActualStyleId(getStyleFromQuery(router, styleQuery, false))
    : getStyleFromQuery(router, styleQuery)

  const routeNames = Object.keys(routes) as AppRouteName[]
  return routeNames.find((routeName: AppRouteName) => {
    const routeCreator = routes[routeName]
    const route =
      routeCreator &&
      routeCreator({ style, sourceType, query, projectId, citationId, paperId })
    if (route && browserURL) {
      const routeWebUrl = routeToHref(route)

      return (
        trimSlashAndQuery(routeWebUrl) ===
        pipe(trimOrigin, basePathUrl, trimSlashAndQuery)(browserURL)
      )
    }
    return false
  })
}
